import dayjs from 'dayjs'

import { CounterValues } from '@/api/models/counters/lib/counters.service'
import { CounterData, Tariff } from '@/api/models/counters/lib/counters.types'
import { getServerNow } from '@/components/entities/common/model/server-time'

const useUpdateCounterCache = (
  counterId: string,
  newCounterValues: CounterValues[]
) => {
  const updateTariff = (tariff: Tariff): Tariff => {
    const updatedTariff = newCounterValues.find(
      newTariff => newTariff.alias === tariff.alias
    )
    if (!updatedTariff) {
      return tariff
    }

    return {
      ...tariff,
      currentValue: Number.parseFloat(updatedTariff.value)
    }
  }

  const updateSingleCounter = (counter: CounterData) => {
    return counter.id === counterId
      ? {
          ...counter,
          lastInputDate: dayjs(getServerNow()).toISOString(),
          tariffs: counter.tariffs
            ? counter.tariffs.map(tariff => updateTariff(tariff))
            : null
        }
      : counter
  }

  const updateCacheData = (cachedData: { data: CounterData[] } | undefined) => {
    if (!cachedData) {
      return cachedData
    }

    return {
      ...cachedData,
      data: cachedData.data.map(counter => updateSingleCounter(counter))
    }
  }

  return { updateCacheData }
}

export { useUpdateCounterCache }
